import React, { forwardRef } from "react";
import { hasWindow } from "@litres/utils";
import type { TForwardRefRefType } from "../../../utils/types";
import { trackerSendHeaderClick } from "../../../utils/analytics";
import { Tab } from "../../Tab";

interface ILoginProps {
  authorizationPopupVisibility?: boolean;
  className?: string;
}

const Login = forwardRef(
  ({ className = "" }: ILoginProps, ref: TForwardRefRefType): JSX.Element => {
    const handleLoginClick = (
      event: React.MouseEvent<Element, MouseEvent>
    ): void => {
      event.preventDefault();
      trackerSendHeaderClick("Войти", hasWindow ? window.location.href : "");
    };

    return (
      <div ref={ref} data-testid="header__login-button--desktop">
        <Tab type="login" classNames={[className]} onClick={handleLoginClick} />
      </div>
    );
  }
);

Login.displayName = "Login";

export default Login;
